import { alpha, Autocomplete, autocompleteClasses, AutocompleteCloseReason, Box, Button, Checkbox, createFilterOptions, InputBase, Menu, useTheme } from '@mui/material';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer';
import { IShopOffer, Leagues } from '../pick6/store/types';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';
import { addBetTypeFilters, removeBetTypeFilters } from './store/slice';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import clsx from 'clsx';
import { IShopOfferCategory, leaguesSorted } from './store/types';
import { getLeague } from '../pick6/optimizerHelper';

interface PopperComponentProps {
  anchorEl?: any;
  disablePortal?: boolean;
  open: boolean;
}

function PopperComponent(props: PopperComponentProps) {
  const { disablePortal, anchorEl, open, ...other } = props;
  const theme = useTheme();
  return <Box {...other} sx={{
    [`& .${autocompleteClasses.paper}`]: {
      boxShadow: 'none',
      margin: 0,
      color: 'inherit',
      fontSize: 13,
    },
    '& .MuiCheckbox-root': {
      padding: 0,
    },
    [`& .${autocompleteClasses.listbox}`]: {
      // backgroundColor: '#fff',
      padding: 0,
      [`& .${autocompleteClasses.option}`]: {
        minHeight: 'auto',
        alignItems: 'flex-start',
        padding: '8px',
        borderBottom: '1px solid #eaecef',
        '&[aria-selected="true"]': {
          backgroundColor: 'transparent',
        },
        [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria - selected= "true"]`]:
        {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
    [`&.${autocompleteClasses.popperDisablePortal}`]: {
      position: 'relative',
    },
  }} />;
}

const OffersFilter = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const offerSortOrder = ["Futures","PlayerFutures","TeamFutures","GameProps","TeamProps","Gamelines","PlayerProps",];
  const { additionalParlayLegFilters, offers, league } = useSelector((state: IRootState) => state.pickemOptimizer);
  const filters = additionalParlayLegFilters.betTypes || [];
  const offerCategories: IShopOfferCategory[] = Object.values(offers);
  console.log("🚀 ~ OffersFilter ~ offerCategories:", offerCategories)
 
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'timeframe-multi-select',
  });

  const filterOptions = createFilterOptions({
    stringify: (option: IShopOffer) => `${option.leagueCode} ${option.name}`
  });

  const updateBetTypeFilter = (event: string, option: IShopOffer | undefined) => {
    if (option === undefined) {
      return;
    }
    if (event === 'selectOption' || event === 'removeOption') {
      !!filters?.find((fd) => fd === option) ? dispatch(removeBetTypeFilters(option)) : dispatch(addBetTypeFilters(option));
    }
  };

  const getDisplayLabel = () => {
    if (filters && filters.length === 1) {
      if (filters[0].name.length > 15) {
        return filters[0].name.substring(0, 14) + '...'
      }
      return filters[0].name;
    }
    return 'Play Types';
  };
  return (
    <React.Fragment>
      <Box data-filter="bettypes" width="auto" sx={{
        '& .MuiButton-root': {
          backgroundColor: 'background.primary',
        },
        '&.MuiButton-outlinedPrimary': {
          color: alpha(theme.palette.common.white, .87),
        },
        '& .MuiSvgIcon-root': {
          color: alpha(theme.palette.common.white, .87),
        },
        '&.selected': {
          backgroundColor: theme.palette.grey[700],
          color: theme.palette.getContrastText(theme.palette.grey[700]),
          fontWeight: 500,
        },
      }}>
        <Button
          aria-controls="button-menu"
          aria-haspopup="true"
          variant="outlined"
          color="primary"
          style={{
            backgroundColor: '#1C1C1C',
            border: '0px'
          }}
          {...bindTrigger(popupState)}
          endIcon={
            filters?.length > 0 ? (
              <Box sx={{
                borderRadius: '50%',
                width: 24,
                height: 24,
                background: theme.palette.primary.main,
                color: theme.palette.common.white,
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '0.875rem !important',
                lineHeight: 1,
              }}> {filters?.length} </Box>
            ) : (
              <ArrowDropDownIcon color="secondary" />
            )
          }
          className={clsx(filters?.length > 0 ? 'selected' : 'none')}
          sx={{
            height: 40,
            minWidth: 125,
            width: '100%',
            maxWidth: '100% !important',
            [theme.breakpoints.down('sm')]: {
              width: '100%',
            },
            justifyContent: 'space-between !important',
            textTransform: 'capitalize !important',
            padding: '4px 12px !important',
            border: `1px solid ${theme.palette.grey[300]}`,
            color: theme.palette.common.white,
            fontWeight: 500,
            fontSize: 13,
            '&.MuiButton-outlinedPrimary': {
              color: theme.palette.common.white
            },
            '& .MuiSvgIcon-root': {
              color: theme.palette.common.white,
            },
            '&.selected': {
              backgroundColor: theme.palette.grey[700],
              color: theme.palette.getContrastText(theme.palette.grey[700]),
              fontWeight: 500,
            },
            '&.disabled': {
              backgroundColor: theme.palette.grey[100],
              color: theme.palette.getContrastText(theme.palette.grey[100]),
              fontWeight: 500,
            },
          }}
        >
          {getDisplayLabel()}
        </Button>
      </Box>
      <Menu {...bindMenu(popupState)} sx={{}}>
        <div>
          <Autocomplete
            open
            multiple
            filterOptions={filterOptions}
            onClose={(
              event: React.ChangeEvent<{}>,
              reason: AutocompleteCloseReason,
            ) => {
              if (reason === 'escape') {
                popupState.setOpen(false);
              }
            }}
            onChange={(event, newValue, reason, selection) => {
              updateBetTypeFilter(reason, selection?.option);
            }}
            disableCloseOnSelect
            PopperComponent={PopperComponent}
            renderTags={() => null}
            value={filters || new Array<IShopOffer>()}
            noOptionsText={'Play Types'}
            renderOption={(props, option) => (
              <li{...props} key={option?.id} >
                <Box
                  sx={{ width: 17, height: 17, mr: '5px', ml: '-2px' }}
                  style={{
                    visibility: !!filters?.find((fd) => fd === option) ? 'visible' : 'hidden',
                  }}
                />
                <Box
                  component="span"
                  sx={{
                    width: 14,
                    height: 14,
                    flexShrink: 0,
                    borderRadius: '3px',
                    mr: 1,
                    mt: '2px',
                  }}
                  style={{}}
                />
                <Box
                  sx={{
                    flexGrow: 1,
                    '& span': {
                      color: '#586069',
                    },
                    fontWeight: 500,
                  }}
                >
                  {option?.name}
                </Box>
                <Checkbox
                  checked={!!filters?.find((fd) => fd === option)}
                  size="small"
                  color="secondary"
                />
              </li>
            )}
            options={offerCategories?.flatMap((o) => o?.offers)
              .filter(x => league === undefined || league === Leagues.ALL || league === x.leagueCode)
              .sort((a, b) => leaguesSorted.indexOf(getLeague(a.leagueCode)) - leaguesSorted.indexOf(getLeague(b.leagueCode))
                || offerSortOrder.indexOf(b.offerCategory) - offerSortOrder.indexOf(a.offerCategory))}
            groupBy={(option) => option?.leagueCode}
            getOptionLabel={(option) => option?.name}
            renderInput={(params) => (
              <InputBase
                ref={params.InputProps.ref}
                inputProps={params.inputProps}
                autoFocus
                placeholder={'Filter Play Types'}
                sx={{
                  padding: '10px',
                  width: '100%',
                  borderBottom: '1px solid #eaecef',
                  '& input': {
                    borderRadius: 4,
                    backgroundColor: 'background.primary',
                    padding: '8px',
                    transition: theme.transitions.create(['border-color', 'box-shadow']),
                    border: '1px solid #eaecef',
                    fontSize: 16,
                    '&:focus': {
                      boxShadow: '0px 0px 0px 3px rgba(3, 102, 214, 0.3)',
                      borderColor: '#0366d6',
                    },
                  },
                }}
              />
            )}
          />
        </div>
      </Menu>
    </React.Fragment>
  )
}

export default OffersFilter